/**
 * Created by filatov on 16.09.2015.
 */
import LeaveHTMLPreviewBalanceOnlyStrategy from './LeaveHTMLPreviewBalanceOnlyStrategy'
import {LeaveTypeColumnConfig} from '../../../leavesReport/LeaveReportConfig'
import LeaveHTMLPreviewGroupingSection from './LeaveHTMLPreviewGroupingSection'
import LeaveHTMLPreviewHeaderSection from './LeaveHTMLPreviewHeaderSection'
import LeaveHTMLPreviewTimeOnlyStrategy from './LeaveHTMLPreviewTimeOnlyStrategy'
import LeaveHTMLPreviewTimeAndBalanceOnlyStrategy from './LeaveHTMLPreviewTimeAndBalanceStrategy'

export default class LeaveHTMLPreviewGenerator {

    constructor() {
    }

    generatePreviewTable = (reportParameters) => {
        let columnsStrategy = this.createPreviewStrategy(reportParameters)

        let header = new LeaveHTMLPreviewHeaderSection().init(
            reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel,
            columnsStrategy
        )

        let dataGroupingSection = new LeaveHTMLPreviewGroupingSection().init(
            reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel,
            columnsStrategy
        )

        let table = document.createElement("table")
        table.className = "reportHtmlPreviewTable leave " + columnsStrategy.getStrategyCssClass()
        let tBody = document.createElement("tbody")
        table.appendChild(tBody)
        header.addRows(tBody)
        dataGroupingSection.addRows(tBody)

        return table
    }

    createPreviewStrategy = (reportParameters) => {
        switch (reportParameters.columnsConfig) {
            case LeaveTypeColumnConfig.LEAVE_TIME_ONLY:
                return new LeaveHTMLPreviewTimeOnlyStrategy().init(reportParameters.timeFormat)
            case LeaveTypeColumnConfig.BALANCES_ONLY:
                return new LeaveHTMLPreviewBalanceOnlyStrategy().init(reportParameters.timeFormat, reportParameters.balanceQualifier)
            case LeaveTypeColumnConfig.LEAVE_TIME_AND_BALANCES:
                return new LeaveHTMLPreviewTimeAndBalanceOnlyStrategy().init(reportParameters.timeFormat, reportParameters.balanceQualifier)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewGenerator.js